import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {NotificationService} from '../notification/notification.service';
import {HttpError} from './http-error';
import {Notification} from '../notification/notification';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  private notificationService = inject(NotificationService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        catchError((response: { error: HttpError }) => {
          const httpError = HttpError.fromDto(response.error);
          const notification = httpError.isValid() ?
            httpError.toNotification() :
            Notification.error('Oeps, er ging iets mis');
          this.notificationService.showNotification(notification);
          return throwError(response);
        })
      );
  }
}
